import { useParams } from 'react-router-dom';
import { useGetModuleSpecsQuery } from '../../../../api/queries/getModuleSpecs';
import { ModuleType } from '../../../../api/types';
import LoadingElement from '../../../../components/LoadingElement';
import NotFoundResult from '../../../../components/results/NotFoundResult';
import UpdateMyInfoSettingInnerPage from './UpdateMyInfoSettingInnerPage';

const UpdateMyInfoSettingPage = () => {
    const { moduleId, myInfoSettingId } = useParams<{ moduleId: string; myInfoSettingId: string }>();

    const { data, loading } = useGetModuleSpecsQuery({
        fetchPolicy: 'cache-first',
        variables: { moduleId },
    });

    if (!data && !loading) {
        return <NotFoundResult />;
    }

    if (loading) {
        return <LoadingElement />;
    }

    const { module } = data;

    if (module.__typename !== ModuleType.MyInfoModule) {
        return <NotFoundResult />;
    }

    const myInfoSetting = module.myInfoSettings.find(item => item.id === myInfoSettingId);

    if (!myInfoSetting) {
        return <NotFoundResult />;
    }

    return <UpdateMyInfoSettingInnerPage module={module} myInfoSettings={myInfoSetting} />;
};

export default UpdateMyInfoSettingPage;
